import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "./style.css";
import Form from './Form.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../DoctorBite.js';
import PatientReviews from '../PatientReview.js';
//import Faq from './Faq.js';
import GetInTouch from '../GetInTouch.js';
import FollowYt from '../FollowYt.js'
import Breadcrumb from '../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Turbinectomy Surgery in Delhi, India | Treatment, Cost & Doctors</title>
            <meta name="description" content="Get expert Turbinectomy surgery in Delhi for nasal blockage and breathing problems. Advanced treatment by experienced ENT specialists for better nasal health." />
            <meta name="keywords" content="Turbinectomy Surgery, Turbinectomy Surgery Delhi, Turbinectomy Surgery Delhi, Turbinoplasty Surgery Delhi, Turbinectomy cost in Delhi, Turbinoplasty cost in Delhi NCR, Nose surgery Delhi, Nasal blockage treatment Delhi, Turbinectomy specialist in Delhi" />
            <link rel="canonical" href="https://entdelhi.com/turbinectomy/" />
            <meta property="og:title" content="Turbinectomy Surgery in Delhi, India | Treatment, Cost & Doctors" />
            <meta property="og:description" content="Get expert Turbinectomy surgery in Delhi for nasal blockage and breathing problems. Advanced treatment by experienced ENT specialists for better nasal health." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
      <main>
        <Breadcrumb/>
        <Form />  
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         {/*<Faq/>*/}
         <GetInTouch/>
      </main>
    </div>
  )
}
